export default __webpack_public_path__ + "static/5-665773cf3efa3771223a6af16c4e6743.png";